export const EXCHANGES_ON_CHANGE_SHIPPING_CLICK = 'EXCHANGES_ON_CHANGE_SHIPPING_CLICK ';
export const EXCHANGES_ON_HIDE_NEW_SHIPPING_ADDRESS_MODAL_CLICK = 'EXCHANGES_ON_HIDE_NEW_SHIPPING_ADDRESS_MODAL_CLICK';
export const EXCHANGES_ON_USE_SHIPPING_ADDRESS_CLICK = 'EXCHANGES_ON_USE_SHIPPING_ADDRESS_CLICK';
export const EXCHANGES_ON_SHOW_ADD_NEW_SHIPPING_ADDRESS_MODAL_CLICK = 'EXCHANGES_ON_SHOW_ADD_NEW_SHIPPING_ADDRESS_MODAL_CLICK';
export const EXCHANGES_USE_SUGGESTED_ADDRESS = 'EXCHANGES_USE_SUGGESTED_ADDRESS';
export const EXCHANGES_CLOSE_SELECT_ADDRESS = 'EXCHANGES_CLOSE_SELECT_ADDRESS';
export const EXCHANGES_EDIT_ADDRESS = 'EXCHANGES_EDIT_ADDRESS';
export const EXCHANGES_VERIFY_ADDRESS_PAGEVIEW = 'EXCHANGES_VERIFY_ADDRESS_PAGEVIEW';
export const EXCHANGES_DELETE_ADDRESS = 'EXCHANGES_DELETE_ADDRESS';
export const EXCHANGES_REQUEST_ALL_ADDRESSES = 'EXCHANGES_REQUEST_ALL_ADDRESSES';
export const EXCHANGES_SAVE_ADDRESS = 'EXCHANGES_SAVE_ADDRESS';
export const EXCHANGES_SET_SELECTED_SHIPPING_ADDRESS_ID = 'EXCHANGES_SET_SELECTED_SHIPPING_ADDRESS_ID';
export const EXCHANGES_SET_SELECTED_SUGGESTED_ADDRESS_ID = 'EXCHANGES_SET_SELECTED_SUGGESTED_ADDRESS_ID';
export const SET_FORM_ERRORS = 'SET_FORM_ERRORS';
export const EXCHANGES_ADD_OR_EDIT_ADDRESS_EVENT = 'EXCHANGES_ADD_OR_EDIT_ADDRESS_EVENT';
export const EXCHANGES_SET_PRIMARY_SHIPPING_ADDRESS = 'EXCHANGES_SET_PRIMARY_SHIPPING_ADDRESS';
